import React from 'react';
import { Box, Typography, Container, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const HeroSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      id="home"
      sx={{
        minHeight: '100vh',
        backgroundImage: 'url(https://images.unsplash.com/photo-1589829545856-d10d557cf95f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        color: '#fff',
        pt: 10 // accommodate fixed header
      }}
    >
      {/* Premium Gradient Overlay */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(to right, rgba(15, 32, 39, 0.95), rgba(32, 58, 67, 0.8), rgba(44, 83, 100, 0.6))'
        }}
      />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
        <Box sx={{ maxWidth: '1000px', }}>
          <Typography
            variant="overline"
            sx={{
              letterSpacing: 3,
              color: '#4db6ac',
              fontWeight: 600,
              mb: 2,
              display: 'block'
            }}
          >
            PREMIER LEGAL COUNSEL
          </Typography>
          <Typography
            variant="h1"
            fontWeight="800"
            gutterBottom
            sx={{
              fontSize: { xs: '2rem', md: '4rem' },
              lineHeight: 1.1,
              mb: 3,
              textShadow: '0 2px 10px rgba(0,0,0,0.3)'
            }}
          >
            Hisham Abdullah Al-Sheikh &amp; Partners Law Firm and Legal Consultants
          </Typography>

          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: '1.1rem', md: '1.25rem' },
              color: 'rgba(255,255,255,0.9)',
              fontWeight: 400,
              lineHeight: 1.6,
              mb: 5,
              maxWidth: '600px'
            }}
          >
            
          A consulting authority in the legal field, and a partner that fulfills the aspirations of its clients.
                            
          </Typography>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3}>
            <Button
              variant="contained"
              size="large"
              endIcon={<ArrowForwardIcon />}
              onClick={() => navigate('/account/signUp')}
              sx={{
                background: '#1f5d3b',
                color: '#fff',
                px: 4,
                py: 1.8,
                borderRadius: '8px',
                fontSize: '1.1rem',
                textTransform: 'none',
                fontWeight: 600,
                boxShadow: '0 8px 16px rgba(31, 93, 59, 0.4)',
                '&:hover': {
                  background: '#16442b',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 12px 20px rgba(31, 93, 59, 0.5)',
                },
                transition: 'all 0.3s ease'
              }}
            >
              Get Started
            </Button>


          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default HeroSection;

